// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getCompanyData, updateCompany, updateTargetStatus } from '../../actions/targets'
import ComponentContainer from '../container-component'
import TableCompanyHistory from '../table-company-history'
import ChartStock from '../chart-stock'
import { StyledCol, RowSymbol, RowPrice, RowChange } from './style'
import { Row, Col, Card } from 'antd'

type Props = {
  targets: {
    isFetching: boolean,
    error: null | string,
    target: string
  },
  company: Object,
  companyList: Object[],
  targetCompany: Object => void,
  loadData: string => void,
  setCompanyStatus: (boolean, string | null) => void
}

class CompanyView extends Component<Props> {

  componentWillMount() {
    const {
        companyList,
        targets: { target },
        setCompanyStatus
    } = this.props
    if ((!companyList || !companyList.length) && !!target) this.loadTargetCompany()
    else if (!target) setCompanyStatus(false, 'No Company Selected')
  }

  componentDidMount() {

    const { 
      companyList, 
      targets: { target },
      setCompanyStatus
    } = this.props
    
    // check redux for companies and if no selection
    if ((!companyList || !companyList.length) && !!target) this.loadTargetCompany()
    else if (!target) setCompanyStatus(false, 'No Company Selected')
  }

  componentDidUpdate(prevProps) {

    const {
      companyList,
      targets: { target },
      targetCompany
    } = this.props

    // check to see if target data is already in redux
    if ((prevProps.targets.target !== target) && !!companyList) {

      const checkList: Object[] = companyList.filter((x: Object) => x.symbol === target)

      if (checkList.length) targetCompany(checkList[0])
      else if (!target) targetCompany({})
      else this.loadTargetCompany()
    }
  }

  loadTargetCompany = () => {

    // fetch data from IEX
    const { 
      loadData,
      targets: { target }
    } = this.props

    if (target) loadData(target)
  }

  render() {

    // company data
    const { 
      company,
      targets: {
        target,
        isFetching,
        error
      }
    } = this.props

    return (
      <section>
        { (isFetching || !!error || !company.symbol) ? 
          (
            <ComponentContainer
              title={(error || !company.symbol) ? 'No Company Selected' : 'Loading Company Data'}
              loading={isFetching}
              empty={(!!error || !company.symbol)}
              resetData={this.loadTargetCompany}>

              <h1>company details</h1>
            </ComponentContainer>
          ) :
          (
            <section>

              {/* Company Details */}
              <Row>
                <StyledCol span={6}>
                  <RowSymbol>{target}</RowSymbol>
                  <RowPrice>${company.price}</RowPrice>
                  <RowChange color={company.changeDollar}>
                    {company.changeDollar > 0 && <span>+</span>}
                    {company.changeDollar}
                    [{company.changePercent > 0 && <span>+</span>}{company.changePercent}%]
                  </RowChange>
                </StyledCol>

                <Col span={18}>
                  <Card
                    bordered={false}
                    loading={!company.name}
                    title={company.name}>
                    {company.description}
                  </Card>
                  <ChartStock symbol={target} />
                </Col>
              </Row>

              {/*/!* Earnings History *!/*/}
              {/*<Row>*/}
                {/*<TableCompanyHistory symbol={target} />*/}
              {/*</Row>*/}
            </section>
          )
        }
      </section>
    )
  }
}

const mapStateToProps = (state: Object) => ({
  targets: state.targets,
  company: state.targets.company,
  companyList: state.targets.companyList
})

const mapDispatchToProps = (dispatch: Function) => ({
  targetCompany(target: Object) {
    dispatch(updateCompany(target))
  },
  loadData(target: string) {
    getCompanyData(dispatch, target)
  },
  setCompanyStatus(isFetching: boolean, error: null | string) {
    dispatch(updateTargetStatus(isFetching, error))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(CompanyView)



// WEBPACK FOOTER //
// ./src/components/tab-company/index.js